import type { BoardMember, BoardTerm } from '@/types/member';

// ─── 2025 – 2027 (current) ───────────────────────────────────────────────────

export const BOARD_MEMBERS_2025_2027: BoardMember[] = [
  {
    id: '44cb2719-904f-4a96-b6c5-e7942d1341a7',
    first_name: 'Daysi',
    last_name: 'Cruz',
    display_name: 'Daysi Cruz',
    position: 'Presidenta',
    position_email: 'presidencia@animacionesmia.com',
    position_responsibilities: [
      'Representar legalmente a la asociación',
      'Dirigir y coordinar las actividades de la Junta Directiva',
      'Convocar y presidir las reuniones de la Junta Directiva y Asamblea General',
      'Supervisar el cumplimiento de los estatutos y acuerdos',
    ],
    profile_image_url: '/images/directiva/daysi-cruz.webp',
    company: 'Morgana Studios',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Directora de Negocios y Ventas en Morgana Studios Madrid. Dominicana con alma madrileña. Con más de 10 años de experiencia en el área audiovisual como productora de cine, eventos y publicidad.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      vimeo: 'https://vimeo.com/714489053',
      twitter: 'daysitacruz',
      website: 'https://www.morganastudios.com',
      linkedin: 'https://www.linkedin.com/in/daysicruzcid/',
      instagram: 'https://www.instagram.com/daysicruzc/',
    },
    main_profession: 'Directora de proyecto',
    other_professions: ['Coordinadora de producción'],
  },
  {
    id: '009b7e0f-11ad-423d-8a56-da30d9f14632',
    first_name: 'Jone',
    last_name: 'Landaluze',
    display_name: 'Jone Landaluze',
    position: 'Vice-Presidenta',
    position_email: 'vicepresidencia@animacionesmia.com',
    position_responsibilities: [
      'Sustituir a la Presidenta en caso de ausencia',
      'Apoyar en la coordinación de actividades',
      'Colaborar en la representación de la asociación',
    ],
    profile_image_url: '/images/directiva/jone-landaluze.webp',
    company: 'Dibulitoon Studio',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: 'País Vasco',
    country: 'España',
    biography:
      'Productora ejecutiva y Directora de producción desde 2010, tomo parte desde el desarrollo hasta el estreno de proyectos de largometrajes y series de animación 3D y 2D.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/jone-landaluze-iribarren-033bb614/',
      instagram: 'https://www.instagram.com/jonemi',
    },
    main_profession: 'Productora',
    other_professions: [],
  },
  {
    id: 'd4a7d04b-63c2-491a-ba42-b5cccca12255',
    first_name: 'Liliana',
    last_name: 'Rincon',
    display_name: 'Liliana Rincon',
    position: 'Secretaria',
    position_email: 'secretaria@animacionesmia.com',
    position_responsibilities: [
      'Levantar actas de reuniones',
      'Gestionar la documentación oficial',
      'Mantener el archivo de la asociación',
    ],
    profile_image_url: '/images/directiva/liliana-rincon.webp',
    company: '3DADOS MEDIA',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Productora y gestora con amplia trayectoria en el fortalecimiento del sector de animación digital en Colombia. Cofundadora de 3DADOS MEDIA, estudio dedicado a la creación de contenidos animados con proyección nacional e internacional. Productora de la primera película colombiana seleccionada en competencia oficial del Festival de Cine de Animación de Annecy, el más importante del mundo en su categoría.\n\nGestora de GEMA Colombia – Grupo de Empresas de Animación, asociación que presidió durante seis años, liderando su consolidación como plataforma clave para el desarrollo del ecosistema de animación en el país.\n\nCreadora del primer curso especializado en Producción para Animación en Colombia, ha participado activamente en la construcción de políticas públicas, la defensa de los estímulos estatales al sector y la promoción de contenidos con identidad propia.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/lilianarinconladinoproducer/',
      instagram: 'https://www.instagram.com/lilianarinconladino',
      website: 'https://3dadosmedia.com/',
    },
    main_profession: 'Productora',
    other_professions: [],
  },
  {
    id: '85e0dad1-67ef-40fa-9a1a-ea9da49eec58',
    first_name: 'Irene',
    last_name: 'Hernández Montoro',
    display_name: 'Irene Hernández Montoro',
    position: 'Tesorera',
    position_email: 'tesoreria@animacionesmia.com',
    position_responsibilities: [
      'Gestionar las finanzas de la asociación',
      'Elaborar presupuestos y cuentas anuales',
      'Controlar ingresos y gastos',
    ],
    profile_image_url: '/images/directiva/irene-hernandez.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: 'Canarias',
    country: 'España',
    biography:
      'Irene es una Production Manager de animación experta en organización, creatividad y eficiencia para proyectos en 2D, 3D y real time. Es alumni de U-TAD y su trayectoria incluye roles clave como Line Producer en Lamola Studio y Coordinadora de Producción en Anima Kitchen, además de experiencia en estudios como Hampa Studio y B-Water Studios.\n\nAporta una visión integral de la industria, habiendo sido Consultora y coordinadora de actividades ICEX en MIFA. Ha asistido a eventos internacionales como Weird Market, Annecy o Ventana Sur, donde ha realizado pitching y networking para impulsar diversos proyectos. Actualmente también compagina la docencia con diferentes trabajos de producción.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/irene-hern%C3%A1ndez-montoro-b701b6187/',
    },
    main_profession: 'Productora',
    other_professions: [],
  },
  {
    id: '38fa9dcc-725c-4d67-8287-5f00b71b168f',
    first_name: 'Rocío',
    last_name: 'Benavent Méndez',
    display_name: 'Rocío Benavent Méndez',
    position: 'Vocal Informes MIA',
    position_email: 'informemia@animacionesmia.com',
    position_responsibilities: [
      'Coordinar la elaboración de informes sobre la industria',
      'Recopilar y analizar datos del sector',
      'Comunicar hallazgos a las socias',
    ],
    profile_image_url: '/images/directiva/rocio-benavent.webp',
    company: 'Saltarinas',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: 'Comunidad Valenciana',
    country: 'España',
    biography:
      'Rocío Benavent Méndez doctora en Industrias de la Comunicación y Culturales. Está licenciada en Comunicación Audiovisual especializada en Animación, Efectos Visuales y Dirección Artística. En 2011 continuó sus estudios de fotografía artística en la Escuela de Arte Superior de Diseño (EASD) y del 2017-2020 trabajó como técnica en el Máster en Animación de la UPV.\n\nTiene un perfil multidisciplinar y de gestión de proyectos. Actualmente combina su docencia en Proyectos de Animación con su empresa de gestión cultural y audiovisual Saltarinas. Ha formado parte del grupo de investigación de Animación UPV y forma parte de la Asociación MIA de la que forma parte de la junta directiva.\n\nInició su producción en el campo de la animación con su primer cortometraje con plastilina stop motion El origen de las Estrellas (2007) pero no fue hasta el cortometraje Todo Bien (2023) donde se inició como productora ejecutiva, siendo nominada a la 32ª edición de los premios Goya en 2024.\n\nTiene muchos intereses pero está especializada en el papel de la mujer en la animación, la coeducación, la animación como herramienta de transformación social, la gestión cultural en la animación, los festivales de animación y el uso de la animación para la creación de nuevos productos culturales.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/company/saltarinas',
      instagram: 'https://www.instagram.com/saltarinasss/',
      website: 'https://saltarinas.com/',
    },
    main_profession: 'Investigadora, productora y profesora',
    other_professions: [],
  },
  {
    id: 'eva-perez-2025',
    first_name: 'Eva',
    last_name: 'Pérez Misa',
    display_name: 'Eva Pérez Misa',
    position: 'Vocal Formacion',
    position_email: 'formacion@animacionesmia.com',
    position_responsibilities: [
      'Organizar talleres y actividades formativas',
      'Detectar necesidades formativas de las socias',
      'Coordinar colaboraciones con instituciones educativas',
    ],
    profile_image_url: '/images/directiva/eva-perez-misa.webp',
    company: 'Freelance',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Eva es una guionista gallego-argentina especializada en proyectos de animación para público infantil y familiar.\n\nActualmente, es la responsable del departamento de guión en las series preschool «Los Wawies» (Imagic Tv, Wawaland & Clan Tv) y «Violeta» (Sultana Films, Clan Tv, Capaz de ajustes & FluMoustache).\n\nEva ha escrito y/o desarrollado series infantiles que se están emitiendo en canales como Netflix, HBO Max, Amazon, Cartoonito, RTL Kids, Clan TV, Boing o Disney Channel y que han sido traducidas a más de una docena de idiomas.\n\nSeries como Bebés Llorones (Hampa Studio & IMC), el exitoso especial de La Granja de Zenón titulado «Bartolito, una aventura emplumada» (El Reino Infantil, Cartoonito & HBO Max), «El Diario de Alice» (Clan TV, Lightbox, Sardinha en Lata & Geppetto Films), «Cuquín» (Anima Kitchen) o la nueva serie y película de «Superthings: El poder del Kazoom» (Tandem Films, Filmax, Magicbox & Clan Tv).',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/eva-p%C3%A9rez-misa',
      instagram: 'https://www.instagram.com/misaevaperez',
      website: 'https://www.evaperezmisa.com',
    },
    main_profession: 'Guionista',
    other_professions: [],
  },
  {
    id: '9091d907-f74a-4da3-8f60-b794ed26d08d',
    first_name: 'Belinda',
    last_name: 'Bonan De Vries',
    display_name: 'Belinda Bonan',
    position: 'Vocal Comunicacion',
    position_email: 'comunicacion@animacionesmia.com',
    position_responsibilities: [
      'Gestionar la comunicación externa de la asociación',
      'Coordinar redes sociales y newsletter',
      'Diseñar estrategias de comunicación',
    ],
    profile_image_url: '/images/directiva/belinda-bonan.webp',
    company: 'MOST WANTED STUDIO',
    membership_type: 'pleno_derecho',
    city: 'Tarragona',
    province: 'Tarragona',
    autonomous_community: 'Cataluña',
    country: 'España',
    biography:
      'Belinda Bonan es guionista, directora y productora, especializada en cine de animación. Es Licenciada en Economía y Comunicación Audiovisual, tiene un diploma en Estudios Avanzados de Animación de Personajes y la Diplomatura de Guion de Cine y TV. Desde 2011, ha trabajado como animadora 3D en varias series de televisión y también ha sido docente de animación 3D en dos escuelas de Barcelona.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      vimeo: 'https://vimeo.com/mostwantedstudio',
      twitter: 'https://twitter.com/belindabonan',
      website: 'https://mostwantedstudio.com',
      linkedin: 'https://www.linkedin.com/in/belindabonan',
      instagram: 'https://www.instagram.com/belindabonan',
    },
    main_profession: 'Directora',
    other_professions: ['Guionista', 'Productora', 'Directora'],
  },
  {
    id: 'micaela-rossi-2025',
    first_name: 'Micaela',
    last_name: 'Rossi',
    display_name: 'Micaela Rossi',
    position: 'Vocal Comunicacion',
    position_email: 'comunicacion@animacionesmia.com',
    position_responsibilities: [
      'Apoyar la comunicación externa de la asociación',
      'Colaborar en redes sociales y contenidos digitales',
      'Contribuir a las estrategias de comunicación',
    ],
    profile_image_url: '/images/directiva/micaela-rossi.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: '',
    country: 'España',
    biography:
      'Micaela Ayelén Rossi es productora audiovisual con formación en Comunicación (URV) y un Máster en Producción (ESCAC). Desde hace 3 años se ha especializado en animación, trabajando como coordinadora de producción en proyectos de animación 2D cut-out y 3D.\n\nAdemás, cuenta con experiencia como guionista de series transmedia y ha desempeñado la dirección de producción en cortometrajes y videoclips de acción real.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/micaela-ayel%C3%A9n-rossi-ba7aaa174',
      instagram: 'https://www.instagram.com/mica_r0ssi',
    },
    main_profession: 'Productora',
    other_professions: [],
  },
  {
    id: 'c95d8fc3-d4aa-4583-9850-f9a2fc799d52',
    first_name: 'Montse',
    last_name: 'Capón',
    display_name: 'Montse Capón',
    position: 'Vocal Financiacion',
    position_email: 'financiacion@animacionesmia.com',
    position_responsibilities: [
      'Buscar oportunidades de financiación',
      'Gestionar subvenciones y patrocinios',
      'Desarrollar estrategias de fundraising',
    ],
    profile_image_url: '/images/directiva/montse-capon.webp',
    company: 'Freelance',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: 'Cataluña',
    country: 'España',
    biography:
      'Profesional del sector de la animación con más de 25 años de experiencia en producción, coproducción internacional, desarrollo de negocio y gestión ejecutiva. Amplia trayectoria en series, películas y cortometrajes de animación para televisión y cine, trabajando con productoras y broadcasters nacionales e internacionales.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/montse-capon-perez-4ab90243/',
      instagram: 'https://www.instagram.com/montsecapon',
    },
    main_profession: 'Productora ejecutiva',
    other_professions: [],
  },
  {
    id: '80452840-9151-49c0-8904-e7f018bb0006',
    first_name: 'Patricia',
    last_name: 'Diaz',
    display_name: 'Patricia Diaz',
    position: 'Vocal Socias',
    position_email: 'socias@animacionesmia.com',
    position_responsibilities: [
      'Gestionar la base de datos de socias',
      'Coordinar el proceso de altas y bajas',
      'Atender consultas de socias',
    ],
    profile_image_url: '/images/directiva/patricia-diaz.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: 'Canarias',
    country: 'España',
    biography:
      'Patri Díaz trabaja en el departamento de arte en proyectos de animación. Estudió Bellas Artes en las Universidades de La Laguna y la Politécnica de Valencia, especializándose en Diseño Gráfico e Ilustración, y más tarde centró su formación en Animación 2D y 3D.\n\nHa trabajado en una amplia variedad de proyectos de animación, desde largometrajes hasta anuncios publicitarios. Entre ellos: Mariposas Negras (Premio Goya a la Mejor Película de Animación 2025), La Violinista (Work in Progress, seleccionado para Annecy 2025), Tsunami (2026) y One-Way Cycle, entre otros.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/patridiazart/',
      instagram: 'https://www.instagram.com/patridiazart/',
      website: 'https://www.patridiazart.com/',
    },
    main_profession: 'Concept Artist',
    other_professions: [],
  },
  {
    id: 'sonia-estevez-2025',
    first_name: 'Sonia',
    last_name: 'Estévez',
    display_name: 'Sonia Estévez',
    position: 'Vocal Festivales',
    position_email: 'festivales@animacionesmia.com',
    position_responsibilities: [
      'Representar a MIA en festivales de animación',
      'Coordinar la participación en eventos del sector',
      'Gestionar relaciones con organizadores de festivales',
    ],
    profile_image_url: '/images/directiva/sonia-estevez.webp',
    company: 'Sonia Estévez Stop Motion Animation SL',
    membership_type: 'pleno_derecho',
    city: 'Álava',
    province: 'Álava',
    autonomous_community: 'País Vasco',
    country: 'España',
    biography:
      'Sonia Estévez es directora, productora, model maker y animadora stop motion. Ha dirigido y producido tres cortometrajes —Txotxongiloa, Malkoak y Plazer bat— por los que ha recibido numerosos premios, y ha dirigido varios anuncios publicitarios en esta técnica.\n\nSe formó en stop motion en Barcelona (Escuela de Animación 9zeros y Cifo de Hospitalet), en producción ejecutiva en la consultora Media Training y realizó los cursos Stop Motion I y II en Aardman Academy. Imparte cursos y talleres de animación para todas las edades.\n\nNominada a los Premios Goya 2024 por Txotxongiloa y candidata a un Goya en 2026 en la categoría de cortometraje de animación por Plazer bat.',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/sonia-estevez-f/',
      instagram: 'https://www.instagram.com/soniesasi/',
      website: 'https://soniaestevez.com/',
    },
    main_profession: 'Directora',
    other_professions: [],
  },
  {
    id: '00a96190-7ad5-45d1-b265-bf3ccdd9b0f9',
    first_name: 'Alicia',
    last_name: 'Núñez Puerto',
    display_name: 'Alicia Núñez Puerto',
    position: 'Vocal Asociaciones',
    position_email: 'asociaciones@animacionesmia.com',
    position_responsibilities: [
      'Colaborar con otras asociaciones del sector',
      'Representar a MIA en eventos interasociativos',
      'Fortalecer alianzas estratégicas',
    ],
    profile_image_url: '/images/directiva/alicia-nunez.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: '',
    country: 'España',
    biography:
      'Directora y productora nominada a los Goya con 20 años de experiencia en la industria de la animación. Berlinale Talent 2026. Alicia ha trabajado en más de 30 grandes producciones para compañías como Aardman Animations, BRB Internacional o Ánima Estudios en países como México, India, UK y España.\n\nMiembro numerario de la Academia de Cine de España y Andalucía, en 2018 fundó junto a otras compañeras MIA, Asociación de Mujeres en la Industria de la Animación española, y fue su primera presidenta electa. Ha impartido clases de guion y producción ejecutiva en la UIC, en la UNAV, en el programa MIAnima y ha sido mentora en CIMA Impulsa, Proyecto Atenea e Ibermedia Next, entre otros.\n\nActualmente, Alicia está escribiendo su primer largometraje como directora, es co-productora ejecutiva de "AZTEC BATMAN" de WB y sigue recorriendo festivales de todo el mundo con su segundo cortometraje como directora "ONE-WAY CYCLE".',
    board_term_start: '2025-01-01',
    board_term_end: '2026-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/alicianunezpuerto/',
      instagram: 'https://www.instagram.com/aliolinu/',
      website: 'https://www.imdb.com/es-es/name/nm5981536/',
    },
    main_profession: 'Directora',
    other_professions: ['Guionista', 'Productora Ejecutiva'],
  },
];

// ─── 2023 – 2025 ─────────────────────────────────────────────────────────────

export const BOARD_MEMBERS_2023_2025: BoardMember[] = [
  {
    id: '4431-veronica-buide',
    first_name: 'Verónica',
    last_name: 'Buide Somoza',
    display_name: 'Verónica Buide Somoza',
    position: 'Presidenta',
    position_responsibilities: [
      'Representar legalmente a la asociación',
      'Dirigir y coordinar las actividades de la Junta Directiva',
      'Convocar y presidir las reuniones de la Junta Directiva y Asamblea General',
    ],
    profile_image_url: '/images/directiva/veronica-buide.webp',
    company: 'Pulpa Rights',
    membership_type: 'pleno_derecho',
    city: 'A Coruña',
    province: 'A Coruña',
    autonomous_community: 'Galicia',
    country: 'España',
    biography:
      'Abogada de propiedad intelectual e industrial, y consultora estratégica de proyectos de entretenimiento. Experta en protección, creación, gestión y desarrollo de negocio internacional de IPs de entretenimiento. La mayor parte de su trayectoria profesional ha transcurrido en empresas del sector audiovisual y editorial, en las que ha tenido el privilegio de trabajar en proyectos como Pocoyó, Jelly Jamm, Pirata y Capitano, Heidi, Maya, Gormiti, Miraculous Ladybug, Milo o Mutant Busters.',
    board_term_start: '2023-01-01',
    board_term_end: '2024-12-31',
    social_media: {},
    main_profession: 'Consultora',
    other_professions: ['CEO', 'Directora de proyecto', 'Distribución y ventas', 'Marketing', 'Productora Ejecutiva'],
  },
  {
    id: '2684-marta-delvalle-2023',
    first_name: 'Marta',
    last_name: 'Del Valle',
    display_name: 'Marta Del Valle',
    position: 'Vice-Presidenta',
    position_responsibilities: [
      'Sustituir a la Presidenta en caso de ausencia',
      'Apoyar en la coordinación de actividades',
    ],
    profile_image_url: '/images/directiva/marta-delvalle.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography: '',
    board_term_start: '2023-01-01',
    board_term_end: '2024-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
  {
    id: '4536-ylka-tapia',
    first_name: 'Ylka',
    last_name: 'Tapia',
    display_name: 'Ylka Tapia',
    position: 'Tesorera',
    position_responsibilities: [
      'Gestionar las finanzas de la asociación',
      'Elaborar presupuestos y cuentas anuales',
    ],
    profile_image_url: '/images/directiva/ylka-tapia.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Tenerife',
    province: '',
    autonomous_community: 'Canarias',
    country: 'España',
    biography: '',
    board_term_start: '2023-01-01',
    board_term_end: '2024-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
  {
    id: '5037-mariana-loterszpil',
    first_name: 'Mariana',
    last_name: 'Loterszpil',
    display_name: 'Mariana Loterszpil',
    position: 'Secretaria',
    position_responsibilities: [
      'Levantar actas de reuniones',
      'Gestionar la documentación oficial',
    ],
    profile_image_url: '/images/directiva/mariana-loterszpil.webp',
    company: 'Latinlab',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Mariana es Productora Ejecutiva, Consultora y especialista en contenidos para las infancias. Además de representar proyectos de animación latinoamericanos, brinda capacitaciones sobre diversidades e inclusión en contenidos para infancia y juventud. Fue una de las fundadoras del canal argentino Pakapaka y luego su productora general, teniendo a cargo todas las producciones del canal desde sus inicios supervisando contenido y presupuesto además de los equipos de trabajo.',
    board_term_start: '2023-01-01',
    board_term_end: '2024-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/mariana-loterszpil-7b76935/',
      instagram: 'https://www.instagram.com/marlot45/',
      website: 'https://latinlab.org',
    },
    main_profession: 'Directora',
    other_professions: ['Coordinadora de producción', 'Directora de producción', 'Productora Ejecutiva', 'Profesora', 'Directora creativa'],
  },
  {
    id: '3753-pilar-diaz-pardo',
    first_name: 'Pilar',
    last_name: 'Díaz Pardo',
    display_name: 'Pilar Díaz Pardo',
    position: 'Vocal',
    position_responsibilities: ['Colaborar en las actividades de la Junta Directiva'],
    profile_image_url: '/images/directiva/pilar-diaz-pardo.webp',
    company: 'THE GLOW',
    membership_type: 'pleno_derecho',
    city: 'Badajoz',
    province: 'Badajoz',
    autonomous_community: 'Extremadura',
    country: 'España',
    biography: '',
    board_term_start: '2023-01-01',
    board_term_end: '2024-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/pilar-d%C3%ADaz-b5655ab0/',
      instagram: 'https://www.instagram.com/pilar.pd/',
    },
    main_profession: 'Directora de producción',
    other_professions: ['Productora Ejecutiva'],
  },
  {
    id: '3234-dacil-roca',
    first_name: 'Dácil',
    last_name: 'Roca Vera',
    display_name: 'Dácil Roca Vera',
    position: 'Vocal',
    position_responsibilities: ['Colaborar en las actividades de la Junta Directiva'],
    profile_image_url: '/images/directiva/dacil-roca.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Tenerife',
    province: '',
    autonomous_community: 'Canarias',
    country: 'España',
    biography: '',
    board_term_start: '2023-01-01',
    board_term_end: '2024-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
];

// ─── 2021 – 2023 ─────────────────────────────────────────────────────────────

export const BOARD_MEMBERS_2021_2023: BoardMember[] = [
  {
    id: '2557-myriam-ballesteros-2021',
    first_name: 'Myriam',
    last_name: 'Ballesteros',
    display_name: 'Myriam Ballesteros',
    position: 'Presidenta',
    position_responsibilities: [
      'Representar legalmente a la asociación',
      'Dirigir y coordinar las actividades de la Junta Directiva',
    ],
    profile_image_url: '/images/directiva/myriam-ballesteros.webp',
    company: 'MB Producciones',
    membership_type: 'pleno_derecho',
    city: 'Álava',
    province: 'Álava',
    autonomous_community: 'País Vasco',
    country: 'España',
    biography:
      'Myriam Ballesteros es creadora, directora y productora de destacadas series y cortos de animación para el público infantil y juvenil. Fundadora de MB Producciones e IMIRA Entertainment, ha sido showrunner, story editor y directora creativa de éxitos internacionales como Lucky Fred, Sandra detective de cuentos, Lola & Virginia o Meme y el Sr. Bobo, vendidas en más de 100 países y premiadas en festivales como CIFF, Annecy o Cartoon on the Bay.',
    board_term_start: '2021-01-01',
    board_term_end: '2022-12-31',
    social_media: {},
    main_profession: 'Directora',
    other_professions: ['Productora', 'Showrunner'],
  },
  {
    id: '2711-paloma-mora',
    first_name: 'Paloma',
    last_name: 'Mora',
    display_name: 'Paloma Mora',
    position: 'Vice-Presidenta',
    position_responsibilities: [
      'Sustituir a la Presidenta en caso de ausencia',
      'Apoyar en la coordinación de actividades',
    ],
    profile_image_url: '/images/directiva/paloma-mora.webp',
    company: 'TV ON Producciones',
    membership_type: 'pleno_derecho',
    city: 'Valencia',
    province: 'Valencia',
    autonomous_community: 'Comunidad Valenciana',
    country: 'España',
    biography:
      'Paloma Mora es Licenciada en Ciencias de la Información y DEA en Comunicación Audiovisual. Es CEO y Productora de TV ON Producciones y Admirable Films, compañías con larga trayectoria en el campo del audiovisual en todos los géneros. Es miembro de la Academia de las Artes y Ciencias Cinematográficas de España, miembro de la Academia de Televisión de España, Presidenta de AVEPA (Asociación valenciana de empresas productoras de Animación) y Vicepresidenta de MIA.',
    board_term_start: '2021-01-01',
    board_term_end: '2022-12-31',
    social_media: {
      website: 'http://tvonproducciones.com/',
    },
    main_profession: 'CEO',
    other_professions: ['Productora Ejecutiva'],
  },
  {
    id: '2684-marta-delvalle-2021',
    first_name: 'Marta',
    last_name: 'Del Valle',
    display_name: 'Marta Del Valle',
    position: 'Tesorera',
    position_responsibilities: [
      'Gestionar las finanzas de la asociación',
      'Elaborar presupuestos y cuentas anuales',
    ],
    profile_image_url: '/images/directiva/marta-delvalle.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography: '',
    board_term_start: '2021-01-01',
    board_term_end: '2022-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
  {
    id: '2561-tania-palma',
    first_name: 'Tania',
    last_name: 'Palma',
    display_name: 'Tania Palma',
    position: 'Secretaria',
    position_responsibilities: [
      'Levantar actas de reuniones',
      'Gestionar la documentación oficial',
    ],
    profile_image_url: '/images/directiva/tania-palma.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Tania Palma es directora de producción y productora ejecutiva de animación. Licenciada en Bellas Artes, inició su carrera como diseñadora gráfica y artista 3D, con formación en animación 3D y VFX. Más adelante se especializó en dirección de producción, combinando su sensibilidad artística con un enfoque técnico y estratégico.',
    board_term_start: '2021-01-01',
    board_term_end: '2022-12-31',
    social_media: {},
    main_profession: 'Directora de producción',
    other_professions: ['Productora Ejecutiva'],
  },
  {
    id: '2558-dune-blanco-2021',
    first_name: 'Dune',
    last_name: 'Blanco',
    display_name: 'Dune Blanco',
    position: 'Vocal',
    position_responsibilities: ['Colaborar en las actividades de la Junta Directiva'],
    profile_image_url: '/images/directiva/dune-blanco.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Dune lleva dedicándose al Desarrollo Visual y Creativo para Animación y Videojuegos por más de 10 años. Ha trabajado para productoras como Cartoon Network, Canal+, Ánima Estudios, BRB Internacional, Tomavistas, Toonz, Lightbox, Social Point, IGG…',
    board_term_start: '2021-01-01',
    board_term_end: '2022-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
  {
    id: '2598-marta-gil',
    first_name: 'Marta',
    last_name: 'Gil',
    display_name: 'Marta Gil',
    position: 'Vocal',
    position_responsibilities: ['Colaborar en las actividades de la Junta Directiva'],
    profile_image_url: '/images/directiva/marta-gil.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Valencia',
    province: 'Valencia',
    autonomous_community: 'Comunidad Valenciana',
    country: 'España',
    biography: '',
    board_term_start: '2021-01-01',
    board_term_end: '2022-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
];

// ─── 2019 – 2020 ─────────────────────────────────────────────────────────────

export const BOARD_MEMBERS_2019_2020: BoardMember[] = [
  {
    id: '00a96190-7ad5-45d1-b265-bf3ccdd9b0f9-2019',
    first_name: 'Alicia',
    last_name: 'Núñez Puerto',
    display_name: 'Alicia Núñez Puerto',
    position: 'Presidenta',
    position_responsibilities: [
      'Representar legalmente a la asociación',
      'Dirigir y coordinar las actividades de la Junta Directiva',
    ],
    profile_image_url: '/images/directiva/alicia-nunez.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: '',
    country: 'España',
    biography:
      'Directora y productora nominada a los Goya con 20 años de experiencia, miembro numerario de la Academia de Cine de España y Andalucía. Ha trabajado en más de 30 grandes producciones para compañías como Aardman Animations, BRB Internacional o Ánima Estudios.',
    board_term_start: '2019-01-01',
    board_term_end: '2020-12-31',
    social_media: {},
    main_profession: 'Directora',
    other_professions: ['Productora'],
  },
  {
    id: '2550-deneb-sabater',
    first_name: 'Deneb',
    last_name: 'Sabater Ventura',
    display_name: 'Deneb Sabater Ventura',
    position: 'Vice-Presidenta',
    position_responsibilities: [
      'Sustituir a la Presidenta en caso de ausencia',
      'Gestionar las finanzas de la asociación (también ejerció como Tesorera)',
    ],
    profile_image_url: '/images/directiva/deneb-sabater.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Deneb Sabater Ventura inicia su andadura profesional en el sector de la animación en Hampa Studio (Valencia) en 2008. Desde entonces ha desarrollado su carrera en el sector de la animación y los VFX a nivel internacional. Con la intención de apoyar la presencia, igualdad de condiciones y visibilidad de las mujeres del sector, Deneb funda junto a otras compañeras la asociación MIA en 2018.',
    board_term_start: '2019-01-01',
    board_term_end: '2020-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
  {
    id: 'reyes-arnal-2019',
    first_name: 'Reyes',
    last_name: 'Arnal Risueño',
    display_name: 'Reyes Arnal Risueño',
    position: 'Secretaria',
    position_responsibilities: [
      'Levantar actas de reuniones',
      'Gestionar la documentación oficial',
    ],
    profile_image_url: '/images/directiva/reyes-arnal.webp',
    company: 'El Ranchito',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Reyes Arnal Risueño (Madrid, 1990) es técnico superior en producción de audiovisuales radio y espectáculos y graduada en Comunicación Audiovisual por la Universidad Complutense de Madrid. En 2011 comenzó su carrera profesional en la producción de informativos de Telemadrid y junto al equipo de Digital Muffin realizando cortometrajes y videoclips.',
    board_term_start: '2019-01-01',
    board_term_end: '2020-12-31',
    social_media: {
      linkedin: 'https://www.linkedin.com/in/reyes-arnal-risue%C3%B1o/',
    },
    main_profession: 'Productora',
    other_professions: ['Supervisora de producción'],
  },
  {
    id: '2557-myriam-ballesteros-2019',
    first_name: 'Myriam',
    last_name: 'Ballesteros',
    display_name: 'Myriam Ballesteros',
    position: 'Vocal',
    position_responsibilities: ['Colaborar en las actividades de la Junta Directiva'],
    profile_image_url: '/images/directiva/myriam-ballesteros.webp',
    company: 'MB Producciones',
    membership_type: 'pleno_derecho',
    city: 'Álava',
    province: 'Álava',
    autonomous_community: 'País Vasco',
    country: 'España',
    biography:
      'Myriam Ballesteros es creadora, directora y productora de destacadas series y cortos de animación para el público infantil y juvenil. Fundadora de MB Producciones e IMIRA Entertainment.',
    board_term_start: '2019-01-01',
    board_term_end: '2020-12-31',
    social_media: {},
    main_profession: 'Directora',
    other_professions: ['Productora'],
  },
  {
    id: '2558-dune-blanco-2019',
    first_name: 'Dune',
    last_name: 'Blanco',
    display_name: 'Dune Blanco',
    position: 'Vocal',
    position_responsibilities: ['Colaborar en las actividades de la Junta Directiva'],
    profile_image_url: '/images/directiva/dune-blanco.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: 'Madrid',
    province: 'Madrid',
    autonomous_community: 'Madrid',
    country: 'España',
    biography:
      'Dune lleva dedicándose al Desarrollo Visual y Creativo para Animación y Videojuegos por más de 10 años.',
    board_term_start: '2019-01-01',
    board_term_end: '2020-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
  {
    id: 'patricia-cano-2019',
    first_name: 'Patricia',
    last_name: 'Cano Rodríguez',
    display_name: 'Patricia Cano Rodríguez',
    position: 'Vocal',
    position_responsibilities: ['Colaborar en las actividades de la Junta Directiva'],
    profile_image_url: '/images/directiva/patricia-cano.webp',
    company: '',
    membership_type: 'pleno_derecho',
    city: '',
    province: '',
    autonomous_community: '',
    country: 'España',
    biography: '',
    board_term_start: '2019-01-01',
    board_term_end: '2020-12-31',
    social_media: {},
    main_profession: '',
    other_professions: [],
  },
];

// ─── Period metadata (used by DirectivaPage period selector) ─────────────────

export const BOARD_TERMS: BoardTerm[] = [
  { label: '2025–2027', members: BOARD_MEMBERS_2025_2027, isCurrent: true },
  { label: '2023–2025', members: BOARD_MEMBERS_2023_2025, isCurrent: false },
  { label: '2021–2023', members: BOARD_MEMBERS_2021_2023, isCurrent: false },
  { label: '2019–2020', members: BOARD_MEMBERS_2019_2020, isCurrent: false },
];

// All board members across all terms (for search / historical views)
export const ALL_BOARD_MEMBERS: BoardMember[] = [
  ...BOARD_MEMBERS_2025_2027,
  ...BOARD_MEMBERS_2023_2025,
  ...BOARD_MEMBERS_2021_2023,
  ...BOARD_MEMBERS_2019_2020,
];
